<template>
  <section class="new-report">
    <content-page page-slug="Report Sick or Dead Deer">
      <div class="content-page__wrapper">
        <IncidentReportForm></IncidentReportForm>
      </div>
    </content-page>
  </section>
</template>

<script>
import IncidentReportForm from "~/components/Forms/IncidentReportForm/IncidentReportForm";
import ContentPage from "~/components/ContentPage/ContentPage.vue";

export default {
  name: "IncidentReport",
  components: {
    IncidentReportForm,
    ContentPage,
  },
  layout: "insidepage",

  data() {
    return {
      page: {
        pageId: null,
        uri: "report",
        slug: "new",
        parent: {
          slug: "Report Sick or Dead Deer",
        },
      },
    };
  },

  head() {
    if (this.chapter) {
      return {
        title: `Living with White-tailed Deer: ${this.chapter.title}`,
      };
    }
    return {
      title: `Living with White-tailed Deer`,
    };
  },
};
</script>

<style scoped></style>
